import styled from "styled-components";
import { mediaMaxWidth } from "../../../utils/mediaQueriesTemplate";

export const Wrapper = styled.footer`
  background-color: #333;
  color: #fff;
  display: ${(props) => {
    if (props.browser === "safari" || props.browser === "ios") {
      return "table";
    }
    return "flex";
  }};
  justify-content: center;
  flex-direction: column;
  position: ${(props) => (props.positionAbsolute ? "absolute" : "unset")};
  top: ${(props) => (props.positionTop ? `${props.positionTop}px` : "680px")};
  width: 100vw;

  @keyframes fadeInUp {
    from {
      opacity: 0;
      -webkit-transform: translate3d(0, 100%, 0);
      transform: translate3d(0, 100%, 0);
    }

    to {
      opacity: 1;
      -webkit-transform: translate3d(0, 0, 0);
      transform: translate3d(0, 0, 0);
    }
  }

  &.fadeInUp {
    -webkit-animation-name: fadeInUp;
    animation-name: fadeInUp;
  }

  &.animated {
    animation-duration: 0.85s;
    animation-fill-mode: both;
  }

  ${mediaMaxWidth.smallDesktop`
    top: 640px;
  `}
`;

export const Inner = styled.div`
  max-width: ${(props) => !props.isIe && "1440px"};
  width: ${(props) => props.isIe && "95vw"};
  display: flex;
  flex: 1;
  justify-content: space-between;
  flex-direction: ${(props) => props.bottom && "column"};

  ${mediaMaxWidth.smallDesktop`
    flex-direction: column;
    align-items: center;
  `}
`;

export const Top = styled.div`
  display: flex;
  justify-content: center;
  padding: 20px 20px 80px 0;

  ${mediaMaxWidth.smallDesktop`
    padding: 10px 10px 40px 10px;
  `}
`;

export const TopColumn = styled.div`
  display: flex;
  flex: ${(props) => props.flex};
  flex-direction: column;

  ${mediaMaxWidth.smallDesktop`
    align-items: center;
  `}
`;

export const Logo = styled.img`
  width: 250px;
`;

export const Contact = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 250px;
`;

export const ContactTitle = styled.div`
  color: #fff;
  font-size: 1.125em;
  font-weight: 600;
  margin: 5px 0;
`;

export const ContactNumber = styled.div`
  color: #fff;
  font-size: 1.125em;
  margin: 3px 0;
  font-weight: 100;
`;

export const LinksTitle = styled.div`
  color: #79D9D9;
  margin: 25px 0 10px 0;
  font-size: 1.125em;
  font-weight: 600;

  ${mediaMaxWidth.smallDesktop`
    display: ${(props) => props.noMobile && "none"};
    margin-top: 35px;
  `}
`;

export const Link = styled.a`
  color: #fff;
  text-decoration: none;
  font-size: 1.125em;
  cursor: pointer;
  margin: 10px 0;

  &:hover {
    text-decoration: underline;
  }
`;

export const TrustPilot = styled.a`
  display: flex;
  flex-direction: column;
  align-items: center;

  ${mediaMaxWidth.smallDesktop`
    padding-top: 35px;
  `}

  iframe {
    pointer-events: none;
  }
`;

export const Middle = styled.div`
  border-top: 1px solid #4f4f4f;
  border-bottom: 1px solid #4f4f4f;
  padding: 20px;
  display: flex;
  justify-content: center;

  ${mediaMaxWidth.smallDesktop`
    padding: 20px 10px;
  `}
`;

export const IconLink = styled.a``;

export const Social = styled.div`
  svg {
    color: #828282;
    font-size: 2.6em;
    cursor: pointer;
    margin-right: 15px;

    &:hover {
      color: #fff;
    }
  }

  ${mediaMaxWidth.smallDesktop`
    margin-bottom: 15px;

    svg {
      margin: 0 7.5px;
    }
  `}
`;

export const MiddleLinks = styled.div`
  display: flex;
  align-items: center;

  ${mediaMaxWidth.smallDesktop`
    flex-direction: column;
  `}
`;

export const MiddleLink = styled.a`
  font-weight: 600;
  color: #828282;
  font-size: 1.125em;
  margin-left: 55px;
  cursor: pointer;
  text-decoration: none;

  &:hover {
    color: #fff;
    text-decoration: underline;
  }

  ${mediaMaxWidth.smallDesktop`
    margin: 10px 0;
  `}
`;

export const Bottom = styled.div`
  padding: 30px 20px;
  display: flex;
  justify-content: center;

  ${mediaMaxWidth.phone`
    padding: 30px 10px;
  `}
`;

export const BottomText = styled.div`
  color: #828282;
  font-size: 1.13em;
  line-height: 1.3em;
  margin-bottom: 15px;
  font-weight: 100;
`;
